import React from 'react';
export var Alert = function () { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
    React.createElement("path", { d: "M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8Z", fill: "#F7C9C7" }),
    React.createElement("path", { d: "M8 11a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z", fill: "#E5554F" }),
    React.createElement("rect", { x: 7.5, y: 3, width: 1, height: 7, rx: 0.5, fill: "#E5554F" }))); };
